module.exports = __webpack_public_path__ + "static/media/Taupe 2-1.79da181b.jpg";